package net.gorillagroove.util

import kotlinx.datetime.*
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder

typealias Seconds = Long

object TimeUtil {
    // This just exists for testing
    internal var timeOverride: Instant? = null
    internal var timeZoneOverride: TimeZone? = null

    // Ok I lied it's no longer just for testing. It's not easy to construct an Instant in Swift so I use this for that, too.
    fun now(): Instant {
        return timeOverride ?: kotlin.time.Clock.System.now()
    }

    fun LocalDate.Companion.current(): LocalDate {
        return now().toLocalDateTime(timeZoneOverride ?: TimeZone.currentSystemDefault()).date
    }
}

object InstantSerializer : KSerializer<kotlin.time.Instant> {
    override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor("Instant", PrimitiveKind.STRING)

    override fun serialize(encoder: kotlinx.serialization.encoding.Encoder, value: kotlin.time.Instant) {
        encoder.encodeString(value.toString())
    }
    override fun deserialize(decoder: Decoder): kotlin.time.Instant {
        return kotlin.time.Instant.parse(decoder.decodeString())
    }
}

typealias Instant = @Serializable(with = InstantSerializer::class) kotlin.time.Instant

// The kotlinx.datetime version of this was removed to "support more idiomatic code",
// which just means they want you to use LocalDate.parse(this) instead of this.toLocalDate().
// I find this ridiculous, as toLocalDate() is way more usable and is chainable.
// It's the more "idiomatic" one. So I'm restoring it.
fun String.toLocalDate(): LocalDate = LocalDate.parse(this)
